import loadable from "@loadable/component";
import Main from "pages/main/Main";
import PublicOnly from "pages/private/PublicOnly";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const MainRedirect = () => {
    const { search, hash } = useLocation();
    return <Navigate to={`/main${search}${hash}`} replace />;
};

//청크 로딩 중 노출되는 로딩 화면
const ChunkLoading = () => (
    <div className="loadingBox active" style={{display:"block"}}>
        <div className="popup_cover"></div>
        <div id="loading" className="loading">
            <img src="/assets/images/basic/loading.svg"/>
        </div>
    </div>
);

//첫 화면(Main)과 오류 화면(PublicOnly)을 제외한 페이지는 진입 시점에 분할 로딩
const lazyPage = (loader) => loadable(loader, { fallback: <ChunkLoading/> });

const BoardDetail = lazyPage(() => import("pages/cs/Detail"));
const Event = lazyPage(() => import("pages/cs/Event"));
const Faq = lazyPage(() => import("pages/cs/Faq"));
const Insurance = lazyPage(() => import("pages/cs/Insurance"));
const Notice = lazyPage(() => import("pages/cs/Notice"));
const Social = lazyPage(() => import("pages/member/Social"));
const Alarm = lazyPage(() => import("pages/mypage/Alarm"));
const Coupon = lazyPage(() => import("pages/mypage/Coupon"));
const Edit = lazyPage(() => import("pages/mypage/Edit"));
const Mypage = lazyPage(() => import("pages/mypage/Mypage"));
const Point = lazyPage(() => import("pages/mypage/Point"));
const Setting = lazyPage(() => import("pages/mypage/Setting"));
const NavigationPage = lazyPage(() => import("pages/private/Navigation"));
const PaymentSuccessPage = lazyPage(() => import("pages/private/Payment"));
const RentDetail = lazyPage(() => import("pages/rent/Detail"));
const RentList = lazyPage(() => import("pages/rent/List"));
const RentPayment = lazyPage(() => import("pages/rent/Payment"));
const RentReservation = lazyPage(() => import("pages/rent/Reservation"));
const ReservationDetail = lazyPage(() => import("pages/reservation/Detail"));
const ReservationEdit = lazyPage(() => import("pages/reservation/Edit"));
const ReservationEditCarList = lazyPage(() => import("pages/reservation/EditCarList"));
const ReservationEditDate = lazyPage(() => import("pages/reservation/EditDate"));
const ReservationList = lazyPage(() => import("pages/reservation/List"));

//type
//login : 로그인 한정 페이지
// notLogin : 비로그인 한정 페이지
// null : 로그인,비로그인 무관 페이지

export const routes = [
    {
        exact: true,
        path: "/pageErr",
        component: <PublicOnly/>,
        type : null
    },
    {
        exact: true,
        path: "/pageErr/:err",
        component: <PublicOnly/>,
        type : null
    },
    {
        exact: true,
        path: "/",
        component: <MainRedirect />,
        type : null
    },
    {
        exact: true,
        path: "/main",
        component: <Main/>,
        type : null
    },
    {
        exact: true,
        path: "/paymentModal",
        component: <PaymentSuccessPage/>,
        type : null
    },
    {
        exact: true,
        path: "/social/:type",
        component: <Social/>,
        type : null
    },
    {
        exact: true,
        path: "/navi/:type",
        component: <NavigationPage/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation",
        component: <ReservationList/>,
        type : "login"
    },
    {
        exact: true,
        path: "/reservation/detail/:id",
        component: <ReservationDetail/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation/edit/:id",
        component: <ReservationEdit/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation/edit/date/:id",
        component: <ReservationEditDate/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation/edit/list/:id",
        component: <ReservationEditCarList/>,
        type : null
    },
    {
        exact: true,
        path: "/rent/list",
        component: <RentList/>,
        type : null
    },
    {
        exact: true,
        path: "/:type/detail/:id/:cCode/:mCode",
        component: <RentDetail/>,
        type : null
    },
    {
        exact: true,
        path: "/rent/reservation",
        component: <RentReservation/>,
        type : null
    },
    {
        exact: true,
        path: "/:type/payment",
        component: <RentPayment/>,
        type : null
    },
    {
        exact: true,
        path: "/faq",
        component: <Faq/>,
        type : null
    },
    {
        exact: true,
        path: "/event",
        component: <Event/>,
        type : null
    },
    {
        exact: true,
        path: "/insurance",
        component: <Insurance/>,
        type : null
    },
    {
        exact: true,
        path: "/notice",
        component: <Notice/>,
        type : null
    },
    {
        exact: true,
        path: "/:type/detail/:id",
        component: <BoardDetail/>,
        type : null
    },
    {
        exact: true,
        path: "/mypage",
        component: <Mypage/>,
        type : "login"
    },
    {
        exact: true,
        path: "/alarm",
        component: <Alarm/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/point",
        component: <Point/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/coupon",
        component: <Coupon/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/setting",
        component: <Setting/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/profile",
        component: <Edit/>,
        type : "login"
    },

];
